import { render, staticRenderFns } from "./RecommendationsList.vue?vue&type=template&id=3326b258&scoped=true&"
import script from "./RecommendationsList.vue?vue&type=script&lang=js&"
export * from "./RecommendationsList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationsList.vue?vue&type=style&index=0&id=3326b258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3326b258",
  null
  
)

export default component.exports